import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChartOfAccountsDataService, ChartOfAccountsModel } from '../../services/chart-of-accounts-data.service';

@Component({
  selector: 'app-chart-of-accounts-add-dialog',
  templateUrl: './chart-of-accounts-add-dialog.component.html',
  styleUrls: ['./chart-of-accounts-add-dialog.component.css'],
})
export class ChartOfAccountsAddDialogComponent implements OnInit {
  adding = false;
  originalFormValues: any;

  accountData: ChartOfAccountsModel = {
    konto: '',
    nazivKonta: '',
  };

  accountDataEdit: ChartOfAccountsModel = {
    konto: '',
    nazivKonta: '',
  };

  constructor(
    public coaDataService: ChartOfAccountsDataService,
    public dialogRef: MatDialogRef<ChartOfAccountsAddDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public importingData: { action: string; data?: ChartOfAccountsModel }
  ) {}

  ngOnInit(): void {
    if (this.importingData?.data) {
      this.accountDataEdit = { ...this.importingData.data };
      this.originalFormValues = { ...this.accountDataEdit };
    }
  }

  async addNewAccountFromDialog() {
    this.adding = true;
    await this.coaDataService.addAccount(this.accountData);
    this.adding = false;
    this.dialogRef.close('res');
  }

  editAccountFromDialog() {
    this.coaDataService.editAccount(this.accountDataEdit);
    this.dialogRef.close();
  }

  isFormDirty(): boolean {
    return JSON.stringify(this.originalFormValues) !== JSON.stringify(this.accountDataEdit);
  }

  isFormValid(): boolean {
    if (this.importingData?.action === 'Add') {
      return !!(this.accountData.konto && this.accountData.nazivKonta);
    } else {
      return !!(this.accountDataEdit.konto && this.accountDataEdit.nazivKonta);
    }
  }
}
